export default __webpack_public_path__ + "media/images/home/slide_hishochi_2026_sm-e89ef792d55644b4c2a48adf47562b9b.jpg";